// import React from 'react'
// import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
// import ValidationText from './ValidationText';

const Divider = ({ item, setItem, activeAccordion, dragHandleProps }) => {
  // const { handleSetDivider } = useNewItemChange(setItem, 'Viewer', activeAccordion);


  return (
    <>
        <div className='px-2'>
          {/* <div className="ar-content-box d-flex flex-column gap-2"> */}
          <div className="text font-m ar-light-color fs-13 pb-1-5">
              <div className='w-100 ar-intake-divider'></div>
          </div>
        </div>
    </>
  );
};

export default Divider